module.exports = __webpack_public_path__ + "static/img/gzh.bc229bbf.jpg";